import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("atlas_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response?.status === 401 && localStorage.getItem("atlas_token")) {
      localStorage.removeItem("atlas_token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  },
);

export const downloadFile = async (path, params, filename) => {
  const res = await api.get(path, { params, responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};

export const downloadCsv = (eventId) => downloadFile("/export/assignments", eventId ? { event_id: eventId } : {}, "atlas-assignments.csv");
